


































































































































































































































import Component, { mixins } from 'vue-class-component';
import { currencyFormat, loadWidget } from '@/utils/helpers';
import { namespace } from 'vuex-class';
import { IAnalyticsOverview } from '@/types/types';
import { Watch } from 'vue-property-decorator';
import WidgetMixins from '@/mixins/WidgetMixins';
import moment from 'moment';
import qs from 'qs';

const analyticsModule = namespace('analytics');

@Component({
  name: 'AnalyticsOverview',
  components: {
    InternetConnection: loadWidget('pages/InternetConnection'),
    ToolBar: loadWidget('widgets/ToolBar'),
    SnackBar: loadWidget('widgets/SnackBar'),
  },
  filters: {
    currencyFormat,
    numberFormat: (value: number) => (value ?? 0).toLocaleString(),
  },
})
export default class AnalyticsOverview extends mixins(WidgetMixins) {
  @analyticsModule.Getter('getOverview') overview!: IAnalyticsOverview | null;

  startDateMenu: boolean = false;
  endDateMenu: boolean = false;
  startDate: string = moment()
    .subtract(30, 'days')
    .format('YYYY-MM-DD');
  endDate: string = moment().format('YYYY-MM-DD');

  headers = [
    { text: 'Date', value: 'date' },
    { text: 'Total', value: 'totalCount', align: 'end' },
    { text: 'Success', value: 'counts.success', align: 'end' },
    { text: 'Failed', value: 'counts.failed', align: 'end' },
    { text: 'Pending', value: 'counts.pending', align: 'end' },
    { text: 'Success Amt.', value: 'amounts.success', align: 'end' },
    { text: 'Failed Amt.', value: 'amounts.failed', align: 'end' },
    { text: 'Pending Amt.', value: 'amounts.pending', align: 'end' },
    { text: 'Total Amt.', value: 'totalAmount', align: 'end' },
  ];

  chartOptions: any = {
    chart: {
      type: 'bar',
      height: 350,
      stacked: true,
      background: 'transparent',
      fontFamily: 'Hanken Grotesk, sans-serif',
      toolbar: { show: false },
    },
    plotOptions: {
      bar: { horizontal: false, columnWidth: '55%', borderRadius: 3 },
    },
    dataLabels: { enabled: false },
    xaxis: { categories: [] },
    yaxis: { title: { text: 'Transactions' } },
    legend: { position: 'top' },
  };

  get isDark(): boolean {
    return this.$vuetify.theme.dark;
  }

  // Chart keeps chronological (ascending) order; the table shows newest first.
  get tableDays(): IAnalyticsOverview['days'] {
    return [...(this.overview?.days ?? [])].reverse();
  }

  get series(): any[] {
    const days = this.overview?.days ?? [];
    return [
      { name: 'Success', data: days.map(day => day.counts.success) },
      { name: 'Failed', data: days.map(day => day.counts.failed) },
      { name: 'Pending', data: days.map(day => day.counts.pending) },
    ];
  }

  @Watch('isDark', { immediate: true })
  onThemeChange(dark: boolean): void {
    const foreColor = dark ? '#9AA3AE' : '#545D68';
    const borderColor = dark ? 'rgba(255, 255, 255, 0.1)' : '#E4E7EB';
    this.chartOptions = {
      ...this.chartOptions,
      theme: { mode: dark ? 'dark' : 'light' },
      tooltip: { theme: dark ? 'dark' : 'light' },
      grid: { borderColor },
      chart: { ...this.chartOptions.chart, foreColor, background: 'transparent' },
      colors: [dark ? '#34D399' : '#10B981', dark ? '#E5675A' : '#D2483A', dark ? '#E0A52B' : '#CF8A09'],
    };
  }

  @Watch('overview')
  onOverviewChange(overview: IAnalyticsOverview | null): void {
    this.chartOptions = {
      ...this.chartOptions,
      xaxis: { categories: (overview?.days ?? []).map(day => day.date) },
    };
  }

  @Watch('startDate')
  onStartDateChange(): void {
    this.fetch();
  }

  @Watch('endDate')
  onEndDateChange(): void {
    this.fetch();
  }

  fetch(): void {
    const query = qs.stringify({ startDate: this.startDate, endDate: this.endDate }, { addQueryPrefix: true });
    this.$store.dispatch('analytics/fetchOverview', query);
  }

  created(): void {
    this.fetch();
  }
}
